"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriorityValue = getPriorityValue;
exports.default = exports.OPTIONS = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _ProjectSettings = require("../ProjectSettings.styles");

var _useRuleSettings = require("../hooks/useRuleSettings");

var _Box = require("./Box.styles");

var _PriorityControl = require("./PriorityControl");

var _routes = require("../../../utils/routes");

const OPTIONS = [{
  label: 'P1',
  value: 1
}, {
  label: 'P2',
  value: 2
}, {
  label: 'P3',
  value: 3
}];
exports.OPTIONS = OPTIONS;

function getPriorityValue(priority, insightType) {
  if (insightType === _routes.InsightType.Insights) {
    return priority;
  }

  let index = OPTIONS.findIndex(item => item.value === priority);

  if (index === -1) {
    index = 0;
  }

  return OPTIONS[index].value;
}

const Content = (0, _styledComponents.default)(_blocks.ActionList)`
  padding: ${_blocks.spacing.tight};
`;

const SettingsBox = ({
  selectedRule
}) => {
  const {
    checked,
    handleCheck,
    updatePriority,
    insightType
  } = (0, _useRuleSettings.useRuleSettings)();
  const handlePriority = React.useCallback(option => {
    const updated = { ...selectedRule,
      priority: option
    };
    updatePriority(updated);
  }, [selectedRule]); // tslint:disable-next-line: strict-type-predicates

  const isActive = selectedRule !== undefined && checked[selectedRule.rule.id] !== undefined;
  const checkboxLabel = isActive ? 'Active' : 'Inactive';
  return /*#__PURE__*/React.createElement(_ProjectSettings.SettingsBoxWrapper, null, /*#__PURE__*/React.createElement(_ProjectSettings.BoxHeader, null, /*#__PURE__*/React.createElement(_ProjectSettings.BoxHeading, null, "Insight Configuration")), selectedRule != null && /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(_Box.RuleName, null, selectedRule.rule.name), /*#__PURE__*/React.createElement(_Box.CheckboxWrap, null, /*#__PURE__*/React.createElement(_blocks.Checkbox, {
    label: checkboxLabel // tslint:disable-next-line: strict-type-predicates
    ,
    checked: checked[selectedRule.rule.id] !== undefined,
    name: "SelectedRuleCheckbox",
    onChange: handleCheck(selectedRule)
  })), /*#__PURE__*/React.createElement(_PriorityControl.PriorityControl, {
    ruleEnabled: isActive,
    key: `${selectedRule.rule.id}`,
    active: getPriorityValue(selectedRule.priority, insightType),
    onChange: handlePriority,
    insightType: insightType
  })));
};

var _default = SettingsBox;
exports.default = _default;